module.exports = __webpack_public_path__ + "img/a5.ba29100e.png";